<script setup lang="ts">
const localePath = useLocalePath()

const { data: list } = useApi('/tournaments', {
  query: {
    page: 1,
    per_page: 3,
    manage: true,
    hide_past: false,
    hide_listing_only: true,
    filter: 'past',
  },
  lazy: true,
  key: 'manage-recent-tournaments',
})
</script>

<template>
  <UiCard :title="$t('Recent tournaments')">
    <template #actions>
      <UiButton
        :to="localePath('/manage/tournaments')"
        :text="$t('View all')"
        icon="tabler-tournament"
        size="sm"
      />
    </template>
    <UiList v-if="list?.data?.length">
      <TournamentCard
        v-for="tournament in list?.data"
        :key="tournament.id"
        :to="localePath(`/manage/tournaments/${tournament.id}`)"
        :tournament="tournament"
      >
        <template #actions>
          <UiButton
            :text="$t('Manage')"
          />
        </template>
      </TournamentCard>
    </UiList>
    <UiCardContent v-else>
      <UiAlert
        :title="$t('No planned tournaments yet.')"
      />
    </UiCardContent>
  </UiCard>
</template>
